import { AfterViewInit, ChangeDetectionStrategy, Component } from '@angular/core';
import { SupportModalIdComponent } from '@lib/components/support-class';
import { CommonLibService, PageInitService } from '@lib/services';
import { AlertType } from '@lib/interfaces';

@Component({
  selector: 'asw-id-sub-test',
  templateUrl: './id-sub-test.component.html',
  styleUrls: ['./id-sub-test.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IdSubTestComponent extends SupportModalIdComponent implements AfterViewInit {
  /** プロパティ定義*/
  public subPageId: string = 'IDSubTest';
  public subFunctionId: string = 'IDSubTest';

  styleClass = 'height_1';

  constructor(private _pageInitService: PageInitService, private _common: CommonLibService) {
    super(_common, _pageInitService);
  }

  init(): void {}
  destroy(): void {}
  reload(): void {}

  warningIdOn(messageId: string) {
    this._common.alertMessageStoreService.setAlertSubWarningMessage({
      contentHtml: messageId,
      isCloseEnable: false,
      alertType: AlertType.WARNING,
      contentId: messageId,
      apiErrorCode: '',
      interpolateParams: { ['0']: 'testWarning' },
    });
  }
  warningIdDelete(messageId: string) {
    this._common.alertMessageStoreService.removeAlertSubWarningMessage(messageId);
  }

  infomationIdOn(messageId: string) {
    this._common.alertMessageStoreService.setAlertSubInfomationMessage({
      contentHtml: messageId,
      isCloseEnable: false,
      alertType: AlertType.INFOMATION,
      contentId: messageId,
    });
  }
  infomationIdDelete(messageId: string) {
    this._common.alertMessageStoreService.removeAlertSubInfomationMessage(messageId);
  }

  alertClear() {
    this._common.alertMessageStoreService.resetAlertMessage();
  }
}
